import { CLEAN_MTOKNA_CAMPAIGN_TEMPLATE, FETCH_MTOKNA_CAMPAIGN_TEMPLATE } from './types';
import { __, request, toNumber } from '../functions';

export const fetchMtoknaCampaignTemplate = (screen, id, campaign_id) => {
    return dispatch => request(`/mtokna/viewCampaignTemplate/${id}/${campaign_id}`).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_CAMPAIGN_TEMPLATE, payload: data });
    });
};

export const createMtoknaCampaignTemplate = (screen, data) => {
    const edit = toNumber(data.id) > 0;

    return dispatch => request(`/mtokna/${edit ? 'editCampaignTemplate' : 'createCampaignTemplate'}`, data, 'POST').then(response => {
        const { status } = response.data;

        screen.setState({ loading: false });

        if (status === 'error') {
            // Nepodarilo sa ulozit sablony
            screen.showSnackbar('error', __('Nepodarilo sa uložiť email'));
            return;
        }

        window.location = '/campaigns';
    });
};

export const cleanMtoknaCampaignTemplate = () => ({ type: CLEAN_MTOKNA_CAMPAIGN_TEMPLATE });
